module.exports = __webpack_public_path__ + "static/img/hotel-star.4baf2e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/hotel-star.png
// module id = drny
// module chunks = 0